import { useState, useEffect } from 'react';
import InteractivePhoneFrame from './components/InteractivePhoneFrame';
import HeroSection from './components/HeroSection';
import Footer from './components/Footer';
import DownloadSection from './components/DownloadSection';
import Header from './components/Header';
import MobileMenu from './components/MobileMenu';
import { PersonaSections } from './components/PersonaSection';
import WhatIsSection from './components/WhatIsSection';
import { personaSections } from './data/content';
import { getElementAnimation } from './utils/animations';
import { useResponsive } from './hooks/useResponsive';

const HASH_SELECTORS: Record<string, string> = {
  '#download': '[data-download-section]',
};

function AppDownloadPage() {
  const isMobile = useResponsive();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const selector = HASH_SELECTORS[window.location.hash];
    if (selector) {
      const timer = setTimeout(() => {
        document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div style={styles.container}>
      <Header isMobile={isMobile} onMenuToggle={() => setMenuOpen(!menuOpen)} />
      <MobileMenu menuOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      {isMobile ? (
        <>
          <InteractivePhoneFrame isMobile={true} />
          <WhatIsSection isMobile={true} />
        </>
      ) : (
        <HeroSection />
      )}
      <PersonaSections
        personaSections={personaSections}
        isMobile={isMobile}
        getElementAnimation={getElementAnimation}
      />
      <DownloadSection isMobile={isMobile} />
      <Footer />
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    color: '#1e293b',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
};

export default AppDownloadPage;
